import { Form, Select, Button, Table, DatePicker, Space, InputNumber, message, Input, Spin } from 'antd';
import { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { ColumnsType } from 'antd/es/table';
import { useNavigate, useParams } from 'react-router-dom';

const { Option } = Select;

interface MovimientoInsumo {
  id: number;
  comprobante_id: number;
  id_insumo: number;
  insumo_descripcion?: string;
  cantidad: number;
  precio_unitario: number;
  tasaiva: number;
  subtotal: number;
  iva: number;
  iinterno: number;
  fecha_entrega: string;
}

interface InsumoData {
  id: number;
  descripcion: string;
  tasaiva: number;
}

interface PadronData {
  id: number;
  razon: string;
  direccion: string;
  localidad: string;
  provincia: string;
}

interface FormaPago {
  fecha_vencimiento: string;
  importe: number;
}

//interface Comprobante {
//  observaciones: string;
//}

const EditarOrdenCompra: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [form] = Form.useForm();
  const { getAccessTokenSilently, isLoading, user } = useAuth0();
  const empresa = user?.id_empresa;
  const sucursal = user?.id_sucursal;
  const [movimientos, setMovimientos] = useState<MovimientoInsumo[]>([]);
  const [insumos, setInsumos] = useState<InsumoData[]>([]);
  const [loading, setLoading] = useState(false);
  const [padronSeleccionado, setPadronSeleccionado] = useState<PadronData | null>(null);
  const [padrones, setPadrones] = useState<PadronData[]>([]);
  const [formasPago, setFormasPago] = useState<FormaPago[]>([]);
  const [formaPagoForm] = Form.useForm();
  const navigate = useNavigate();
  console.log('user', user);
  const [observacion, setObservacion] = useState<string>('');
  const [nroComprobante, setNroComprobante] = useState<string>('');
  const fetchData = async () => {
    try {
      const token = await getAccessTokenSilently();
      const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      };
      console.log('empresa', empresa, 'sucursal', sucursal);
      const insumosResponse = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/listar_insumos/${empresa}`, {
        method: 'GET',
        headers
      });
      const insumosData = await insumosResponse.json();
      setInsumos(insumosData);
      console.log('insumos', insumosData);
    } catch (error) {
      console.error('Error cargando datos:', error);
      message.error('Error al cargar datos iniciales');
    }
  };

  const fetchComprobanteData = async () => {
    try {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      };

      // Primero cargar padrones
      const padronesResponse = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/listar_padron/${empresa}`, {
        method: 'GET',
        headers
      });

      if (!padronesResponse.ok) {
        throw new Error('Error al cargar padrones');
      }

      const padronesData: PadronData[] = await padronesResponse.json();
      console.log('Padrones cargados:', padronesData);
      setPadrones(padronesData);

      // Luego cargar el comprobante
      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/comprobante_ocompra/${empresa}/${sucursal}/${id}`, {
        method: 'GET',
        headers
      });

      if (!response.ok) throw new Error('Error al cargar el comprobante');

      const data = await response.json();
      console.log('Datos del comprobante:', data);

      // Cargar observaciones y padrón
      if (data.comprobante && data.comprobante.length > 0) {
        const comprobante = data.comprobante[0];
        setNroComprobante(comprobante.nro_comprobante || '');
        setObservacion(comprobante.observacion || '');

        const padronId = parseInt(comprobante.id_padron);
        console.log('ID del padrón extraído:', padronId);
        console.log('Lista de padrones después de cargar:', padronesData);

        const padronEncontrado: PadronData | undefined = padronesData.find(p => p.id === padronId);
        console.log('Padrón encontrado:', padronEncontrado);

        if (padronEncontrado) {
          setPadronSeleccionado(padronEncontrado);
          form.setFieldsValue({ padron: padronId });
        }
      }

      // Cargar insumos y otros datos
      await fetchData();

      // Cargar movimientos
      if (data.movimientos) {
        const movimientosFormateados = data.movimientos.map((mov: any) => ({
          id: mov.id,
          comprobante_id: mov.comprobante_id,
          id_insumo: mov.id_insumo,
          insumo_descripcion: mov.insumo_descripcion,
          cantidad: mov.cantidad,
          precio_unitario: mov.precio_unitario,
          tasaiva: mov.tasaiva,
          subtotal: mov.subtotal,
          iva: mov.iva,
          iinterno: mov.iinterno,
          fecha_entrega: mov.fecha_entrega
        }));
        console.log('Movimientos formateados:', movimientosFormateados);
        setMovimientos(movimientosFormateados);
      }

      // Cargar formas de pago
      if (data.formasPago) {
        const formasPagoFormateadas = data.formasPago.map((fp: any) => ({
          fecha_vencimiento: fp.fecha_pago,
          importe: fp.importe
        }));
        setFormasPago(formasPagoFormateadas);
      }

    } catch (error) {
      console.error('Error:', error);
      message.error('Error al cargar el comprobante');
    } finally {
      setLoading(false);
    }
  };

  // Modificar el useEffect para la carga inicial
  useEffect(() => {
    if (!isLoading && id) {
      fetchComprobanteData();
    }
  }, [isLoading, id]);

  const columns: ColumnsType<MovimientoInsumo> = [
    {
      title: 'Entrega',
      dataIndex: 'fecha_entrega',
      width: '10%',
      render: (text: string) => new Date(text).toLocaleDateString()
    },
    {
      title: 'Insumo',
      dataIndex: 'insumo_descripcion',
      width: '35%'
    },
    {
      title: 'IVA %',
      dataIndex: 'tasaiva',
      width: '5%',
      align: 'right',
      render: (value: number) => `${value}%`
    },
    {
      title: 'Cantidad',
      dataIndex: 'cantidad',
      width: '15%',
      align: 'right'
    },
    {
      title: '$ Unitario',
      dataIndex: 'precio_unitario',
      width: '15%',
      align: 'right',
      render: (value: number) => `$${value.toFixed(2)}`
    },
    {
      title: 'Subtotal',
      dataIndex: 'subtotal',
      width: '15%',
      align: 'right',
      render: (value: number) => `$${value.toFixed(2)}`
    },
    {
      title: '',
      key: 'acciones',
      width: '5%',
      render: (_: any, record: MovimientoInsumo) => (
        <Button
          type="link"
          onClick={() => handleRemoveItem(record)}
          style={{ padding: '0px' }}
        >
          Eliminar
        </Button>
      ),
    },
  ];

  const handleAddItem = (values: any) => {
    const insumoSeleccionado = insumos.find(i => i.id === values.insumo_descripcion);
    const subtotal = values.cantidad * values.precio_unitario;

    if (!insumoSeleccionado) {
      message.error('No se encontró el insumo');
      return;
    }

    const newItem: MovimientoInsumo = {
      id: 0,
      comprobante_id: 0,
      id_insumo: insumoSeleccionado.id,
      // insumo: insumoSeleccionado.descripcion,
      insumo_descripcion: insumoSeleccionado.descripcion,
      fecha_entrega: values.fecha_entrega.format(),
      cantidad: values.cantidad,
      precio_unitario: values.precio_unitario,
      tasaiva: insumoSeleccionado.tasaiva,
      subtotal,
      iva: 0,
      iinterno: 0
    };

    setMovimientos([...movimientos, newItem]);
    form.resetFields();
  };

  const handleRemoveItem = (record: MovimientoInsumo) => {
    setMovimientos(movimientos.filter(item => item !== record));
  };

  const handleAddFormaPago = (values: any) => {
    const newFormaPago: FormaPago = {
      fecha_vencimiento: values.fecha_vencimiento.format(),
      importe: values.importe
    };
    setFormasPago([...formasPago, newFormaPago]);
    formaPagoForm.resetFields();
  };

  const handleRemoveFormaPago = (record: FormaPago) => {
    setFormasPago(formasPago.filter(item => item !== record));
  };

  const formaPagoColumns: ColumnsType<FormaPago> = [
    {
      title: 'Fecha Venc.',
      dataIndex: 'fecha_vencimiento',
      width: '15%',
      render: (text: string) => new Date(text).toLocaleDateString()
    },
    {
      title: 'Importe',
      dataIndex: 'importe',
      width: '15%',
      align: 'right',
      render: (value: number) => `$${value.toFixed(2)}`
    },
    {
      title: '',
      key: 'acciones',
      width: '5%',
      render: (_: any, record: FormaPago) => (
        <Button
          type="link"
          onClick={() => handleRemoveFormaPago(record)}
          style={{ padding: '0px' }}
        >
          Eliminar
        </Button>
      ),
    },
  ];

  const handleUpdate = async () => {
    try {
      setLoading(true);
      const token = await getAccessTokenSilently();

      const datosActualizados = {
        padron: padronSeleccionado?.id,
        observacion,
        movimientos: movimientos.map(mov => ({
          ...mov,
          id_insumo: mov.id_insumo,
          fecha_entrega: mov.fecha_entrega
        })),
        formas_pago: formasPago
      };

      console.log('Datos a enviar:', datosActualizados);

      const response = await fetch(`${process.env.REACT_APP_INSUMOS_URL}/comprobante_ocompra/${empresa}/${sucursal}/${id}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(datosActualizados)
      });

      if (!response.ok) throw new Error('Error al actualizar');

      message.success('Comprobante actualizado correctamente');
      // Redirigir a la lista de órdenes de compra
      navigate('/listar_ocompra');

    } catch (error) {
      console.error('Error:', error);
      message.error('Error al actualizar el comprobante');
    } finally {
      setLoading(false);
    }
  };

  // Agregar esta función para calcular los totales
  //  const calcularTotalMovimientos = () => {
  //    return movimientos.reduce((sum, item) => 
  //      sum + Number(item.subtotal) , 0
  //    );
  //  };

  //  const calcularTotalFormasPago = () => {
  //    return formasPago.reduce((sum, item) => sum + Number(item.importe), 0);
  //  };

  // Estilo para el contenedor de forma de pago
  const formaPagoStyle = {
    marginTop: '20px',
    width: '750px',  // Aproximadamente el mismo ancho que el formulario de ingreso
  };

  // Estilo para la tabla de forma de pago
  const tablePagoStyle = {
    marginTop: '10px',
  };

  // Función para validar el formulario
  const isValidForm = () => {
    // Verificar que haya un padrón seleccionado
    if (!padronSeleccionado || !padronSeleccionado.id) {
      return false;
    }

    // Verificar que haya al menos un movimiento
    if (movimientos.length === 0) {
      return false;
    }

    // Verificar que haya al menos una forma de pago
    if (formasPago.length === 0) {
      return false;
    }

    // Calcular totales
    const totalMovimientos = movimientos.reduce((sum, mov) => sum + mov.subtotal, 0);
    const totalFormasPago = formasPago.reduce((sum, fp) => sum + fp.importe, 0);

    // Verificar que los totales coincidan
    return Math.abs(totalMovimientos - totalFormasPago) < 0.01;
  };

  // Función para obtener información sobre la diferencia de totales
  const getDiferenciaInfo = () => {
    if (!padronSeleccionado) {
      return {
        mensaje: "Debe seleccionar un proveedor válido",
        color: "#ff4d4f"  // rojo
      };
    }

    if (movimientos.length === 0) {
      return {
        mensaje: "Debe agregar al menos un movimiento",
        color: "#ff4d4f"
      };
    }

    if (formasPago.length === 0) {
      return {
        mensaje: "Debe agregar al menos una forma de pago",
        color: "#ff4d4f"
      };
    }

    const totalMovimientos = movimientos.reduce((sum, mov) => sum + mov.subtotal, 0);
    const totalFormasPago = formasPago.reduce((sum, fp) => sum + fp.importe, 0);
    const diferencia = totalMovimientos - totalFormasPago;

    if (Math.abs(diferencia) < 0.01) {
      return {
        mensaje: "Los totales coinciden",
        color: "#52c41a"  // verde
      };
    }

    return {
      mensaje: `Diferencia: $${Math.abs(diferencia).toFixed(2)}`,
      color: "#ff4d4f"  // rojo
    };
  };

  // Modificar el handleCancel
  const handleCancel = () => {
    console.log('Ejecutando handleCancel');
    navigate('/listar_ocompra');
  };

  return (
    <div style={{ padding: '20px' }}>
      {loading ? (
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '300px'
        }}>
          <Spin size="large" tip="Cargando datos..." />
        </div>
      ) : (
        <>
          {/* Título */}
          <div style={{
            marginBottom: '20px',
            textAlign: 'center'
          }}>
            <h2>Editar Orden {nroComprobante && `Nº ${nroComprobante}`}</h2>
          </div>

          {/* Contenedor del padrón */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            marginBottom: '20px'
          }}>
            <Form.Item
              name="padron"
              label="Proveedor"
              rules={[{ required: true, message: 'Por favor seleccione un padrón' }]}
              style={{ width: '100%', maxWidth: '400px' }}
            >
              <Select
                showSearch
                placeholder="Seleccione un padrón"
                optionFilterProp="children"
                onChange={(value) => {
                  const padron = padrones.find(p => p.id === value);
                  setPadronSeleccionado(padron || null);
                }}
                filterOption={(input, option) =>
                  (option?.children as unknown as string)
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                value={padronSeleccionado?.id}
              >
                {padrones.map(padron => (
                  <Option key={padron.id} value={padron.id}>
                    {padron.razon}
                  </Option>
                ))}
              </Select>
            </Form.Item>

            {padronSeleccionado && (
              <div style={{
                width: '100%',
                maxWidth: '500px',
                padding: '15px',
                background: '#f5f5f5',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}>
                <p style={{ margin: '5px 0' }}><strong>Nombre   :</strong> {padronSeleccionado.razon}</p>
                <p style={{ margin: '5px 0' }}><strong>Direccion:</strong> {padronSeleccionado.direccion}</p>
                <p style={{ margin: '5px 0' }}><strong>Localidad:</strong> {padronSeleccionado.localidad}</p>
                <p style={{ margin: '5px 0' }}><strong>Provincia:</strong> {padronSeleccionado.provincia}</p>
              </div>
            )}
          </div>

          {/* Formulario y tabla de movimientos */}
          <Form form={form} onFinish={handleAddItem} layout="inline">
            <Form.Item
              name="fecha_entrega"
              label="Entrega"
              rules={[{ required: true }]}
            >
              <DatePicker format="DD/MM/YYYY" style={{ width: '120px' }} />
            </Form.Item>

            <Form.Item
              name="insumo_descripcion"
              label="Insumo"
              rules={[{ required: true }]}
              style={{ width: '300px' }}
            >
              <Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.children as unknown as string)
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
              >
                {insumos.map(ins => (
                  <Option key={ins.id} value={ins.id}>{ins.descripcion}</Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              name="cantidad"
              label="Cantidad"
              rules={[{ required: true }]}
            >
              <InputNumber
                min={0}
                step={0.01}
                style={{ width: '80px' }}
              />
            </Form.Item>

            <Form.Item
              name="precio_unitario"
              label="$ Unitario"
              rules={[{ required: true }]}
            >
              <InputNumber
                min={0}
                step={0.01}
                style={{ width: '100px' }}
                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              />
            </Form.Item>

            <Form.Item>
              <Button type="primary" htmlType="submit">
                +
              </Button>
            </Form.Item>
          </Form>

          <Table
            scroll={{ x: 'max-content' }}
            dataSource={movimientos}
            columns={columns}
            pagination={false}
            summary={(pageData) => {
              if (!pageData.length) return null;

              const total = pageData.reduce((sum, item) => sum + item.subtotal, 0);

              return (
                <Table.Summary fixed="bottom">
                  <Table.Summary.Row style={{
                    backgroundColor: '#fafafa',
                    fontWeight: 'bold'
                  }}>
                    <Table.Summary.Cell index={0} />
                    <Table.Summary.Cell index={1} />
                    <Table.Summary.Cell index={2} />
                    <Table.Summary.Cell index={3} />
                    <Table.Summary.Cell index={4} align="right">
                      ${total.toFixed(2)}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell index={5} />
                  </Table.Summary.Row>
                </Table.Summary>
              );
            }}
          />

          {/* Contenedor de Forma de Pago */}
          <div style={formaPagoStyle}>
            <div style={{ marginBottom: '10px' }}>
              <h3>FORMA DE PAGO:</h3>
            </div>

            <Form form={formaPagoForm} onFinish={handleAddFormaPago} layout="inline">
              <Form.Item
                name="fecha_vencimiento"
                label="Fecha Venc."
                rules={[{ required: true }]}
              >
                <DatePicker format="DD/MM/YYYY" style={{ width: '120px' }} />
              </Form.Item>

              <Form.Item
                name="importe"
                label="Importe"
                rules={[{ required: true }]}
              >
                <InputNumber
                  style={{ width: '100px' }}
                  formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  min={0}
                  step={0.01}
                />
              </Form.Item>

              <Form.Item>
                <Button type="primary" htmlType="submit">
                  +
                </Button>
              </Form.Item>
            </Form>

            <Table
              scroll={{ x: 'max-content' }}
              dataSource={formasPago}
              columns={formaPagoColumns}
              pagination={false}
              style={tablePagoStyle}
              size="small"
              summary={(pageData) => {
                if (!pageData.length) return null;
                const total = pageData.reduce((sum, item) => sum + (item.importe || 0), 0);
                return (
                  <Table.Summary fixed="bottom">
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={0} />
                      <Table.Summary.Cell index={1} align="right">
                        ${total.toFixed(2)}
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={2} />
                    </Table.Summary.Row>
                  </Table.Summary>
                );
              }}
            />
          </div>

          {/* Observaciones */}
          <div style={{
            marginTop: '20px',
            width: '750px'
          }}>
            <div style={{ marginBottom: '10px' }}>
              <h3>OBSERVACIONES:</h3>
            </div>
            <Input.TextArea
              rows={4}
              placeholder="Ingrese las observaciones"
              style={{ width: '100%' }}
              value={observacion}
              onChange={(e) => setObservacion(e.target.value)}
            />
          </div>

          {/* Botones de finalización y mensaje de diferencia */}
          <div style={{
            marginTop: '20px',
            width: '750px'
          }}>
            <div style={{
              display: 'flex',
              justifyContent: 'flex-end',
              marginBottom: '10px'
            }}>
              <Space>
                <Button
                  onClick={handleCancel}
                  type="default"
                >
                  Cancelar
                </Button>
                <Button
                  type="primary"
                  onClick={handleUpdate}
                  disabled={!isValidForm()}
                  loading={loading}
                >
                  Actualizar Orden
                </Button>
              </Space>
            </div>

            {/* Mensaje de diferencia */}
            <div style={{
              textAlign: 'right',
              color: getDiferenciaInfo().color,
              fontWeight: 'bold',
              fontSize: '14px'
            }}>
              {getDiferenciaInfo().mensaje}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default EditarOrdenCompra;
